/**
 * Actions Types
 */

export enum ContratosTypes {
  CONTRATOS_SUCCESS = '@contratos/CONTRATOS_SUCCESS',
  CONTRATOS_ERROR = '@contratos/CONTRATOS_ERROR',
  CONTRATOS_REQUEST = '@contratos/CONTRATOS_REQUEST',
  CONTRATOS_NAO_ELEGIVEIS = '@contratos/CONTRATOS_NAO_ELEGIVEIS',
  CONTRATOS_ELEGIVEIS = '@contratos/CONTRATOS_ELEGIVEIS',
  SET_CONTRATOS_SELECIONADOS = '@contratos/SET_CONTRATOS_SELECIONADOS',
  SET_CONVENIO_SELECIONADO = '@contratos/SET_CONVENIO_SELECIONADO',
  SET_ORGAO_SELECIONADO = '@contratos/SET_ORGAO_SELECIONADO',
  SET_MATRICULA_SELECIONADA = '@contratos/SET_MATRICULA_SELECIONADA',
  SET_CONVENIO_CODIGO_SELECIONADO = '@contratos/SET_CONVENIO_CODIGO_SELECIONADO',
  SET_ORGAO_CODIGO_SELECIONADO = '@contratos/SET_ORGAO_CODIGO_SELECIONADO',
  SET_CODIGO_PRODUTO = '@contratos/SET_CODIGO_PRODUTO',
  REFINANCING_BEGIN_REQUEST = '@contratos/REFINANCING_BEGIN_REQUEST',
  REFINANCING_BEGIN_SUCCESS = '@contratos/REFINANCING_BEGIN_SUCCESS',
  REFINANCING_BEGIN_ERROR = '@contratos/REFINANCING_BEGIN_ERROR',
  SET_CONVENIO_NAME = '@contratos/SET_CONVENIO_NAME',
}

/**
 * Data Type
 */

export interface Contratos {
  descricaoConvenio: string
  listMatricula: Matricula[]
}

export interface Matricula {
  numeroMatricula: string
  listContrato: Contrato[]
}

export interface Contrato {
  numeroContrato: string
  numeroProposta: string
  numParcelasPagas: number
  numParcelasTotais: number
  valorProximaParcela: number
  vencimentoProximaParcela: string
  valorQuitacao: number
  valorEmprestimo: number
  taxa: number
  orgaoDesc: string
  convenioDesc: string
  indisponivel?: boolean
  convenioId: number
  orgaoId: number
  codProduto: number
}

export interface ContratoSelecionado {
  valorQuitacao: number
  numeroContrato: string
  numeroMatricula: string
  numeroProposta: string
  valorProximaParcela: number
  taxa: number
  convenioDesc: string
  orgaoDesc: string
  convenioId: number
  orgaoId: number
  codProduto: number
}

/**
 * State Type
 */

export interface ContratosState {
  readonly listaContratos?: Contratos[]
  readonly contratosError?: boolean
  readonly contratosLoading?: boolean
  readonly convenioSelecionado: string
  readonly orgaoSelecionado: string
  readonly matriculaSelecionada: string
  readonly contratosSelecionados: ContratoSelecionado[]
  readonly elegivel?: boolean
  readonly convenioCodigo: number
  readonly orgaoCodigo: number
  readonly codigoProduto: number
  readonly convenioName: string
}

export interface ContratosAPI {
  errorCode?: string
  contratos: Contratos[]
  elegivel?: boolean
}

export type ContratosRequestPayload = {
  cpf?: string
  newApiVersion?: boolean
  sangueLaranja?: boolean
  semContratosCallback: () => void
  successCallback: () => void
}

export type RefinancingBeginRequestPayload = {
  successCallback: () => void
  errorCallback: () => void
}

interface ContractItem {
  contract: string
  proposal: string
  registration: string
  outstandingBalance: number
  installmentAmount: number
  productCode: number
  categoryId: number
  categoryDescription: string
  agencyId: number
  agencyDescription: string
  eligibleLoanRefinancing: boolean
}

interface Registration {
  registration: string
  contractItems: ContractItem[]
}

interface Contract {
  categoryDescription: string
  registrations: Registration[]
}

export interface ContractsData {
  errorCode?: string
  contracts: Contract[]
  hasEligibleContracts: boolean
}
